<div class="cardaccordion" >
    <mat-accordion class="accordion"  multi >
      <mat-expansion-panel #expansion expanded="true" (opened)="open()" (closed)="close()">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <b>Filtros</b>            
          </mat-panel-title>
          <mat-panel-description>
            <button mat-stroked-button color="accent" (click)="novo($event)" [hidden]="showFilter">Novo</button>
            <div class="vl" [hidden]="showFilter"></div>
            <button mat-stroked-button color="success" (click)="editar($event)" [hidden]="showFilter">Editar</button>
            <div class="vl" [hidden]="showFilter"></div>
            <button mat-stroked-button color="primary" (click)="salvar($event)" [hidden]="!showFilter">Salvar</button>
            <button mat-stroked-button color="warn" (click)="excluir($event)" [hidden]="showFilter">Excluir</button>
            <div class="vl" [hidden]="!showFilter"></div>
            <button mat-stroked-button color="secundary" (click)="cancelar($event)" [hidden]="!showFilter">Cancelar</button>
            <div class="vl"></div>
            <mat-icon>filter_list</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
    
      <div [hidden]="showFilter">
        
        <div class="filterclass">
          <mat-form-field>
            <mat-label>Selecionar um filtro</mat-label>
            <mat-select [(ngModel)]="selectedValue" name="filtro" multiple #selectFilter>
              <mat-option *ngFor="let filter of filters" [value]="filter">
                {{filter.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
    
      </div>
      
      <filterview [hidden]="!showFilter" [allFields]="dataRowColumns" #filter [editing]="editing">

      </filterview>

    </mat-expansion-panel>
    
  </mat-accordion>
</div>